import styled from 'styled-components';
import activeClassName from 'gatsby-theme-menus/src/components/nav/activeClassName';
import NavItem from 'gatsby-theme-menus/src/components/nav/list-nav/nav-item';
import NavLink from 'gatsby-theme-menus/src/components/nav/list-nav/nav-link';
import ChildLink from 'gatsby-theme-menus/src/components/nav/list-nav/child-link';
import NavBeam from 'gatsby-theme-header/src/components/header/nav-beam';

export default styled(NavBeam)`
  background-color: black;

  ${NavItem}:hover,
  ${NavLink}:hover, ${NavLink}.${activeClassName},
  ${ChildLink}:hover, ${ChildLink}.${activeClassName} {
    background-color: #2C2A2A;
  }
`;
